export default __webpack_public_path__ + "static/media/amazon.3de9eb21.png";